import angular from 'angular';
import component from './template-detail.component';
import AlertChipPatternDirective from '../../../../modules/alerts/rules/rules-detail/chip-pattern.directive';
import contactGroupWarnings from './contact-group-warnings';
import escalationBuilder from '../../escalation-builder';
import thresholdBuilder from '../../threshold-builder';

const templateDetailModule = angular
    .module('dt.components.organization-alert-config.alert-templates.template-detail', [
        contactGroupWarnings,
        escalationBuilder,
        thresholdBuilder
    ])
    .component('templateDetail', component)
    .directive('dtAlertChipPattern', AlertChipPatternDirective);

export default templateDetailModule.name; 